export const PAGES_MENU_ADMIN = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'menu.dashboard',
            icon: 'ion-android-home',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'change-password',
        data: {
          menu: {
            title: 'menu.change-password',
            hidden:true,
          }
        }
      },
      {
        path: 'profile',
        data: {
          menu: {
            title: 'menu.profile',
            hidden:true,
          }
        }
      },
      {
        path: 'users',
        data: {
            menu:{
                title: 'menu.users',
                icon: 'ion-person-stalker',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'members',
                data: {
                    menu: {
                        title: 'menu.users_list',
                        icon: 'ion-person-stalker',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_user',
                        icon: 'ion-person-add',
                    },
                },
            }
        ],
      },
      {
        path: 'groups_committees',
        data: {
            menu:{
                title: 'menu.groups',
                icon: 'ion-ios-people',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'groups',
                data: {
                    menu: {
                        title: 'menu.group_list',
                        icon: 'ion-ios-people',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_group',
                        icon: 'ion-android-add',
                    },
                },
            }
        ],
      },
      {
        path: 'campaigns',
        data: {
            menu:{
                title: 'menu.campaigns',
                icon: 'ion-speakerphone',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.campaigns_list',
                        icon: 'ion-speakerphone',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_campaign',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'meetings',
        data: {
            menu:{
                title: 'menu.meetings',
                icon: 'ion-briefcase',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.meetings_list',
                        icon: 'ion-briefcase',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_meeting',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'tasks',
        data: {
            menu:{
                title: 'menu.tasks',
                icon: 'ion-compose',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.tasks_list',
                        icon: 'ion-compose',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_task',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'surveys',
        data: {
            menu:{
                title: 'menu.surveys',
                icon: 'ion-clipboard',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.surveys_list',
                        icon: 'ion-clipboard',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_survey',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'notifications',
        data: {
            menu:{
                title: 'menu.notifications',
                icon: 'ion-ios-bell',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.notifications_list',
                        icon: 'ion-ios-bell',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_notification',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      }
    ]
  }
];


export const PAGES_MENU_PRESIDENT = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'menu.dashboard',
            icon: 'ion-android-home',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'change-password',
        data: {
          menu: {
            title: 'menu.change-password',
            hidden:true,
          }
        }
      },
      {
        path: 'profile',
        data: {
          menu: {
            title: 'menu.profile',
            hidden:true,
          }
        }
      },
      {
        path: 'groups_committees',
        data: {
            menu:{
                title: 'menu.groups',
                icon: 'ion-ios-people',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'groups',
                data: {
                    menu: {
                        title: 'menu.group_list',
                        icon: 'ion-ios-people',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_group',
                        icon: 'ion-android-add',
                    },
                },
            }
        ],
      },
      {
        path: 'campaigns',
        data: {
            menu:{
                title: 'menu.campaigns',
                icon: 'ion-speakerphone',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.campaigns_list',
                        icon: 'ion-speakerphone',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_campaign',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'meetings',
        data: {
            menu:{
                title: 'menu.meetings',
                icon: 'ion-briefcase',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.meetings_list',
                        icon: 'ion-briefcase',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_meeting',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'tasks',
        data: {
            menu:{
                title: 'menu.tasks',
                icon: 'ion-compose',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.tasks_list',
                        icon: 'ion-compose',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_task',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'surveys',
        data: {
            menu:{
                title: 'menu.surveys',
                icon: 'ion-clipboard',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.surveys_list',
                        icon: 'ion-clipboard',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_survey',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'notifications',
        data: {
            menu:{
                title: 'menu.notifications',
                icon: 'ion-ios-bell',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.notifications_list',
                        icon: 'ion-ios-bell',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_notification',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      }
    ]
  }
];


export const PAGES_MENU_ORGANIZATOR = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'menu.dashboard',
            icon: 'ion-android-home',
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'change-password',
        data: {
          menu: {
            title: 'menu.change-password',
            hidden:true,
          }
        }
      },
      {
        path: 'profile',
        data: {
          menu: {
            title: 'menu.profile',
            hidden:true,
          }
        }
      },
      {
        path: 'groups_committees',
        data: {
            menu:{
                title: 'menu.groups',
                icon: 'ion-ios-people',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'groups',
                data: {
                    menu: {
                        title: 'menu.group_list',
                        icon: 'ion-ios-people',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_group',
                        icon: 'ion-android-add',
                    },
                },
            }
        ],
      },
      {
        path: 'campaigns',
        data: {
            menu:{
                title: 'menu.campaigns',
                icon: 'ion-speakerphone',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.campaigns_list',
                        icon: 'ion-speakerphone',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_campaign',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'meetings',
        data: {
            menu:{
                title: 'menu.meetings',
                icon: 'ion-briefcase',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.meetings_list',
                        icon: 'ion-briefcase',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_meeting',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'tasks',
        data: {
            menu:{
                title: 'menu.tasks',
                icon: 'ion-compose',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.tasks_list',
                        icon: 'ion-compose',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_task',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'surveys',
        data: {
            menu:{
                title: 'menu.surveys',
                icon: 'ion-clipboard',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.surveys_list',
                        icon: 'ion-clipboard',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_survey',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      },
      {
        path: 'notifications',
        data: {
            menu:{
                title: 'menu.notifications',
                icon: 'ion-ios-bell',
                selected: false,
                expanded: false,
                order: 0
            }
        },
        children: [
            {
                path: 'list',
                data: {
                    menu: {
                        title: 'menu.notifications_list',
                        icon: 'ion-ios-bell',
                    },
                },
            },
            {
                path: 'add',
                data: {
                    menu: {
                        title: 'menu.add_notification',
                        icon: 'ion-plus-round',
                    },
                },
            }
        ],
      }
    ]
  }
];








// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/pages/pages.menu.ts